import React, { useEffect, useState } from 'react'
import Select from 'meinian-package/src/baseComponent/select'
import { getIndustry } from '../util'

const convert = (result) => {
  return result.map(m => ({ label: m, value: m }))
}
export default (props) => {
  const { gender, platformId, disabled, ...otherProps } = props
  const [options, setOptions] = useState([])
  useEffect(() => {
    if (!gender || !platformId) return
    getSeasons()
  }, [gender, platformId])
  const getSeasons = async () => {
    try {
      const res = JSON.parse(sessionStorage.getItem('meinianFilters')).find(f => f.itemName === '季度')?.itemTreeValue[platformId][getIndustry(gender)]
      setOptions(convert(res))
    } catch (err) {
      console.error(err)
    }
  }

  return <Select {...otherProps} data={options} disabled={disabled} placeholder="不限" />
}
